export const DEFAULT_STATE = {
  availableMetrics: [],
  metricGroups: [],
  metricLoader: false,
  groupMetricLoader: false
}
